// extracted by mini-css-extract-plugin
module.exports = {"bot-image-message":"randy-chat-widget-style-bot-image-message","bot-image-message-without-buttons":"randy-chat-widget-style-bot-image-message-without-buttons"};